module.exports = __webpack_public_path__ + "static/media/apprient.fc0be1af.webp";